export const splitColors = {
    insiderBlue: "#31c0f0",
    toggleActive: "rgb(194, 0, 0)",
    homeGoOut: "#00b9f5"
};
